<template>
  <div class="file-picker">
    <img
      v-if="isImage"
      v-show="value"
      class="selected-image"
      ref="selected-image"
    />
    <b-field class="file">
      <b-upload v-model="value" @input="upload" :accept="accept">
        <a class="button" :class="`${$attrs['type']} ${$attrs['size']}`">
          <b-icon :icon="$attrs['icon-left'] || 'upload'"></b-icon>
          <span>{{ buttonLabel }}</span>
        </a>
      </b-upload>
      <span class="file-name" v-if="value">{{ value.name }}</span>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'FilePicker',
  props: {
    isImage: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: File,
      default: null
    },
  },
  data() {
    return {
      uploadPercent: 0
    }
  },
  computed: {
    acceptedFile() {
      return this.isImage && !this.accept ? 'image/*' : this.accept
    },
    buttonLabel() {
      if (!this.label) {
        let label = this.isImage ? 'image' : 'file'
        return !this.value ? `Pick ${label}` : `Pick another ${label}`
      }
      return this.label
    }
  },
  methods: {
    upload(file) {
      if (this.isImage) {
        const imageRef = this.$refs['selected-image']
        const reader = new FileReader()

        reader.onload = function (e) {
          imageRef.setAttribute('src', e.target.result)
        }

        reader.readAsDataURL(file)
      }
      this.$emit('input', file)
    },
    progressEvent(progressEvent) {
      this.uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    }
  }
}
</script>
